import { enqueueSnackbar } from "notistack"
import { Box, Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBan } from "@fortawesome/pro-solid-svg-icons"
import { makeStyles } from "tss-react/mui"

import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { StandardButton } from "../../../../../../../shared/components/buttons/StandardButton"

import { useWeekMenu } from "../../WeekMenuContext"

const useStyles = makeStyles()((theme) => ({
    panel: {
        position: "relative",
        zIndex: 3,
        minHeight: "100%",
        padding: ".75rem",
        background: theme.palette.tailwind.slate[50],
        borderRight: `1px solid ${theme.palette.tailwind.slate[200]}`,
        borderBottom: `1px solid ${theme.palette.tailwind.slate[200]}`,
        textAlign: "center",
    },
    accentBar: {
        position: "absolute",
        left: 0,
        top: 0,
        bottom: 0,
        width: ".25rem",
        background: theme.palette.tailwind.slate[400],
    },
    icon: {
        color: theme.palette.tailwind.slate[600],
        "& svg": {
            fontSize: "2rem",
        },
    },
    title: {
        color: theme.palette.tailwind.slate[600],
        fontWeight: 700,
    },
    message: {
        color: theme.palette.tailwind.slate[600],
        maxWidth: "11.25rem",
    },
}))

type Props = Readonly<{
    dayIndex: number
}>

export function ClosedDayPanel({ dayIndex }: Props) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const { actions, dayLabels } = useWeekMenu()

    const handleReopen = () => {
        actions.setDayClosed(dayIndex, false)
        enqueueSnackbar({
            variant: "info",
            message: l10n.getString("merchant-week-menu-day-reopened-snackbar", { day: dayLabels[dayIndex] }),
        })
    }

    return (
        <Stack alignItems="center" justifyContent="center" spacing="1.5rem" className={classes.panel}>
            <Box className={classes.accentBar} />
            <Stack spacing=".75rem" alignItems="center">
                <Box className={classes.icon}>
                    <FontAwesomeIcon icon={faBan} />
                </Box>
                <Stack spacing=".25rem" alignItems="center">
                    <LocalizedStrict id="merchant-week-menu-closed-panel-title">
                        <Typography variant="body2" className={classes.title}>
                            Closed
                        </Typography>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-week-menu-closed-panel-message">
                        <Typography variant="caption" className={classes.message}>
                            No menu on this day. Customers see this day as closed.
                        </Typography>
                    </LocalizedStrict>
                </Stack>
            </Stack>
            <LocalizedStrict id="merchant-week-menu-closed-reopen-button">
                <StandardButton fullWidth={false} size="small" variant="outlined" color="black" onClick={handleReopen}>
                    Reopen day
                </StandardButton>
            </LocalizedStrict>
        </Stack>
    )
}
